












import Vue from "vue";
import { closeBrowser } from "@/utils/bridge";

export default Vue.extend({
  data() {
    return {
      desc: "你可以前往「个人页-弹幕宝箱」继续参加活动哦～等你回来！"
    };
  },
  methods: {
    back() {
      this.$dialog.close("back");
      // 关闭主活动页
      closeBrowser();
    }
  }
});
